<template>
  <div class="datepicker-with-arrow">
    <button
      class="datepicker-with-arrow__button"
      @click.stop="onClickSubButton">
      <MaterialIcon
        icon="arrow_left" />
    </button>
    <span class="ml-1 mr-1">
      <b-form-datepicker
        v-model="_value"
        value-as-date
        hide-header
        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        class="datepicker-with-arrow__label"
        menu-class="datepicker-with-arrow__menu" />
    </span>
    <button
      class="datepicker-with-arrow__button"
      @click.stop="onClickAddButton">
      <MaterialIcon
        icon="arrow_right" />
    </button>
  </div>
</template>

<script>
import { addDays } from 'date-fns'
export default {
  props: {
    value: {
      type: [String, Date],
      required: true
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    }
  },
  methods: {
    onClickAddButton() {
      this._value = addDays(this._value, 1)
    },
    onClickSubButton() {
      this._value = addDays(this._value, -1)
    }
  }

}
</script>

<style lang="scss">
.datepicker-with-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  
  &__button {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: $white;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
  }

  &__label {
    background-color: transparent !important;
    & > button {
      display: none;
    }

    label {
      font-weight: bold;
    }
  }

  &__menu {
    top: 40px !important;
    transform: translate(-35%, 0%) !important;
  }
}
</style>